export const sortingFns = {
    date: 'sortingDateFn',
    text: 'sortingTextFn',
    number: 'sortingNumberFn',
    currency: 'sortingNumberFn',
    status: 'sortingStatusFn',
    staffMember: 'sortingStaffMemberFn',
    progressBar: 'sortingProgressFn',
}
